import type { Components } from '@/api/generated/api';

type UploadPermit = Components.Schemas.FileUploadPermitDto;
type UploadedFile = Components.Schemas.UploadedFileDto;

interface IDirectUploadApi {
  initiate: (file: File, checksum: string) => Promise<UploadPermit>;
  complete: (uploadId: number) => Promise<UploadedFile>;
}

/** One attempt per invocation. Failed or unlinked uploads are cleaned up by the backend. */
export async function uploadDirectFile(file: File, api: IDirectUploadApi): Promise<UploadedFile> {
  const digest = new Uint8Array(await crypto.subtle.digest('SHA-256', await file.arrayBuffer()));
  const checksum = btoa(String.fromCharCode(...digest));
  const permit = await api.initiate(file, checksum);
  const form = new FormData();
  for (const [key, value] of Object.entries(permit.fields)) form.append(key, value);
  form.append('file', file);
  const response = await fetch(permit.url, { method: 'POST', body: form, credentials: 'omit' });
  if (!response.ok) throw new Error(`S3 upload failed (${response.status})`);
  return api.complete(permit.uploadId);
}
